import { TabUtilisateurComponent } from './../../../@theme/components/tabs/tabUtilisateur/tabUtilisateur.component';
import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../environments/environment'
import { UtilisateurService } from '../../../services/utilisateur.service';
import { Utilisateur } from '../../../models/utilisateur.model';
@Component({
  selector: 'app-param-utilisateur',
  templateUrl: './param-utilisateur.component.html',
  styleUrls: ['./param-utilisateur.component.scss']
})
export class ParamUtilisateurComponent implements OnInit {
  utilisateurs: Utilisateur[];
  constructor(private utilisateurService: UtilisateurService) { 
    this.utilisateurService.get_utilisateurs().subscribe((res: any[]) => {
      res.forEach((element, index) => {
        res[index] = element.utilisateur;
      });
      this.utilisateurs = res;
    });
  }

  ngOnInit() {
  }
}

